import styled from "@emotion/styled";
import { Colors, FontSizeInPx } from "@snapchat/snap-design-system";

export const TextContent = styled.span`
    overflow: hidden;
    flex-shrink: 0;

    width: 150px;

    font-size: ${FontSizeInPx.COMPACT}px;
    line-height: 18px;
    color: ${Colors.Black.V100};
    text-overflow: ellipsis;
    white-space: nowrap;
`;
